define('home/views/ActivityActorsHoverCard',[  // eslint-disable-line requirejs/amd-function-arity
    'underscore',
    'backbone',
    'home/models/Session',
    'core/views/UsersCard',
    'core/views/common/HoverCard',

    // imported for side effects
    'home/utils/cardUtils',
], function (
    _,
    Backbone,
    Session,
    UsersCard,
    HoverCard
) {
    'use strict';

    var ActivityActorsHoverCard = UsersCard.extend({
        initialize: function (options) {
            var activityFeedItem = options.activityFeedItem;
            var numShownActors = options.numShownActors;

            // Update users collection and all counts to remove the users already shown in
            // the reason line. Those aren't counted/displayed in this hover card.
            _.extend(options, {
                numUsers: activityFeedItem.get('totalActors') - numShownActors,
                session: Session.get(),
                collection: new Backbone.Collection(activityFeedItem.actors.slice(numShownActors)),
            });

            UsersCard.prototype.initialize.apply(this, arguments);
        },

        show: function () {
            UsersCard.prototype.show.apply(this, arguments);

            this.trigger('uiAction:activityActorsCardShow');
        },
    }, {
        create: function (options) {
            return HoverCard.create(options.activityId, options, 'ActivityActorsHoverCard', ActivityActorsHoverCard);
        },
    });

    return ActivityActorsHoverCard;
});

